export enum MeetingType {
    Online="ONLINE",
    InPerson = "IN PERSON",
    OnlineOrInPerson = "ONLINE OR IN PERSON",
}

export enum MeetingTypeEnum {
    ONLY_ONLINE= 'onlyOnlineSessionsChoiceV1',
    ONLY_IN_PERSON= 'onlyInPersonSessionsChoiceV1',
    ACCEPTING_CLIENTS= 'acceptingNewClientChoice',
    NOT_ACCEPTING_CLIENTS= 'notAcceptingNewClientChoice',
    EITHER_TELETHERAPY_OR_IN_PERSON_SESSIONS= "eitherTeletherapyOrInPersonSessionsChoiceV1",
}